import { commonApi } from '@common/utils/baseQuery';

export interface IRecommendedExpressLeg {
  eventId: number;
  outcomeSportId: number;
  outcomeItemId: number;
  value: string;
  odd: number;
  sportId: number;
  sportName: string;
  host: string;
  guest: string;
  champ: string;
  startsAt: number;
  outcomeLabel: string;
  info?: { outcomeSportId: number; outcomeItemId: number; value: string }[];
}

export interface IRecommendedExpress {
  basedOn?: { sportId: number; alias: string; name: string; count: number }[];
  personalized?: boolean;
  legs: IRecommendedExpressLeg[];
  combinedOdd?: number;
  validUntil?: number;
}

export interface IRecommendedExpressParams {
  exclude: number[];
  roll: number;
}

export const recommendedExpressQuery = ({ exclude, roll }: IRecommendedExpressParams) => {
  const params = [ exclude.length ? `exclude=${exclude.join(',')}` : '', `roll=${roll}` ].filter(Boolean);
  return `/recommendations/express?${params.join('&')}`;
};

export const recommendedExpressApi = commonApi.injectEndpoints({
  endpoints: (build) => ({
    fetchRecommendedExpress: build.query<IRecommendedExpress, IRecommendedExpressParams>({
      query: recommendedExpressQuery,
      keepUnusedDataFor: 0,
      transformResponse: (response: IRecommendedExpress | undefined) => ({
        ...(response ?? {}),
        legs: Array.isArray(response?.legs) ? response!.legs : [],
      }),
    }),
  }),
});

export const { useFetchRecommendedExpressQuery } = recommendedExpressApi;
